import React, { useCallback, useEffect, useState } from "react";
import { FaSearch } from "react-icons/fa"; // Import search icon
import EmployeeCard from "./EmployeeCard";
import ApiEndpoints from "../network/ApiEndPoints";
import { get } from "../network/ApiController";
import { apiErrorToast } from "../utils/ToastUtil";

const Developers = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  const refreshUser = useCallback(async () => {
    setLoading(true);
    get(
      `${ApiEndpoints.GET_USERS_BIGG}?role=developer`,
      "",
      setLoading,
      (res) => {
        setUsers(res.data.data);
        setLoading(false);
      },
      (error) => {
        apiErrorToast(error);
        setLoading(false);
      }
    );
  }, []);

  useEffect(() => {
    refreshUser();
  }, []);

  return (
    <div
      style={{
        padding: "40px 20px",
        backgroundColor: "#f4f6f9",
        minHeight: "100vh",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
          borderBottom: "2px solid #ccc", // Divider line
          paddingBottom: "10px",
        }}
      >
        <h1 style={{ fontSize: "2rem", color: "#2c3e50", margin: 0 }}>
          Developer Details
        </h1>

        <div
          style={{
            position: "relative",
            display: "flex",
            alignItems: "center",
          }}
        >
          <input
            type="text"
            placeholder="Search developers..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              padding: "10px 35px 10px 15px", // Adjust padding for icon
              fontSize: "1rem",
              borderRadius: "20px",
              border: "1px solid #ccc",
              outline: "none",
              width: "400px",
            }}
          />
          <FaSearch
            style={{
              position: "absolute",
              right: "12px",
              color: "#777",
              cursor: "pointer",
            }}
          />
        </div>
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(2, 1fr)",
          justifyItems: "center",
          padding: "0 20px",
          gap: "20px",
        }}
      >
        {users.map((employee) => (
          <EmployeeCard key={employee.id} employee={employee} />
        ))}
      </div>
    </div>
  );
};

export default Developers;
